import React from 'react';
import { navigateAction } from 'fluxible-router';
import config from '../../config/client';
import Popover from '../../../client/components/Popover';
import AuthModal from '../AuthModal';
import AccountSettingsModal from '../AccountSettingsModal';
import shallowCompare from '../../lib/shallowCompare';
import CustomerActions from '../../actions/CustomerActions';
import Customer from '../../models/Customer';
import Store from '../../models/Store';
import styles from './index.sass';
import banquetFooterLogo from '../Footer/images/banquet_footer_logo_3x.png';

const PoweredBy = (
  <a className={styles.poweredBy} href={config.BanquetUrl} target="_blank">
    <span>Powered By</span>
    <img src={banquetFooterLogo} alt="Powered By Banquet" />
  </a>
);

class AuthPopover extends React.Component {
  static propTypes = {
    customer: React.PropTypes.instanceOf(Customer),
    store: React.PropTypes.instanceOf(Store)
  };

  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func,
    buildURLForRoute: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      popoverIsOpen : false,
      showAuthModal: false,
      showAccountSettingsModal: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    if(!prevState.popoverIsOpen && this.state.popoverIsOpen) {
      this.context.trackEvent('view', {value: 'account'});
    }
    if(!prevState.showAccountSettingsModal && this.state.showAccountSettingsModal) {
      this.context.trackEvent('view', {value: 'settings'});
    }
  }

  handleOnBodyClick(e) {
    this.setState({popoverIsOpen: false});
  }

  handleOnClickOpenButton(e) {
    if(!this.props.customer || !this.props.customer.isSignedIn()) {
      return this.setState({showAuthModal: true});
    }
    this.setState({popoverIsOpen: !this.state.popoverIsOpen});
  }

  handleOnCloseAuthModal() {
    this.setState({showAuthModal: false});
  }

  handleOnCloseAccountSettingsModal() {
    this.setState({showAccountSettingsModal: false});
  }

  handleOnClickSettingsLink(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({
      popoverIsOpen: false,
      showAccountSettingsModal: true
    });
    return;
  }

  handleOnClickGenericLink(url, e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({popoverIsOpen: false});

    this.context.executeAction(navigateAction, {url: url});

    return;
  }

  renderAuthModal() {
    if(!this.state.showAuthModal) {return null;}
    let authModalProps = {
      onClose: this.handleOnCloseAuthModal.bind(this)
    };
    return <AuthModal {...authModalProps} />;
  }

  renderAccountSettingsModal() {
    if(!this.state.showAccountSettingsModal) {return null;}
    let accountSettingsModalProps = {
      onClose: this.handleOnCloseAccountSettingsModal.bind(this),
      store: this.props.store
    };
    return <AccountSettingsModal {...accountSettingsModalProps} />;
  }

  render() {
    let { popoverIsOpen } = this.state;
    let { customer, store } = this.props;
    if(!customer) {return null;}
    let signOutUrl = this.context.buildURLForRoute('signOut');
    let signOutLinkProps = {
      href: signOutUrl,
      onClick: this.handleOnClickGenericLink.bind(this, signOutUrl)
    };
    let settingsLinkProps = {
      href: this.context.buildURLForRoute('settings'),
      onClick: this.handleOnClickSettingsLink.bind(this)
    };

    let orderHistoryLink;
    if(store) {
      let orderHistoryUrl = this.context.buildURLForRoute('orderHistory');
      let orderHistoryLinkProps = {
        href: orderHistoryUrl,
        onClick: this.handleOnClickGenericLink.bind(this, orderHistoryUrl)
      };
      orderHistoryLink = <li><a {...orderHistoryLinkProps}>Order history</a></li>;
    }

    let popoverBody = (
      <div className={styles.authPopover}>
        <div className={styles.contactInfo}>
          {customer.name ? <p className={styles.name}>{customer.name}</p> : null}
          <p className={styles.email}>{customer.email}</p>
        </div>
        <ul className={styles.links}>
          {orderHistoryLink}
          <li><a {...settingsLinkProps}>Settings</a></li>
          <li><a {...signOutLinkProps}>Sign out</a></li>
        </ul>
        {PoweredBy}
      </div>
    );
    let popoverProps = {
      body        : popoverBody,
      position    : 'right',
      isOpen      : popoverIsOpen,
      onBodyClick : this.handleOnBodyClick.bind(this),
      bodyClassName : styles.popoverBody + ` ${store ? '' : styles.noStore}`,
      bodyStyle   : {}
    };
    let buttonProps = {
      className: `${styles.openButton} ${popoverIsOpen ? styles.open : ''} ${store ? '' : styles.noStore}`,
      onClick: this.handleOnClickOpenButton.bind(this)
    };

    return (
      <Popover {...popoverProps}>
        <span>
          <button {...buttonProps}>{customer.isSignedIn() ? `Account` : `Sign in`}</button>
          {this.renderAuthModal()}
          {this.renderAccountSettingsModal()}
        </span>
      </Popover>
    );
  }
}

export default AuthPopover;



// WEBPACK FOOTER //
// banquet/components/AuthPopover/index.js